import PropTypes from 'prop-types';
import account from '#props/account';

export default {
  classes: PropTypes.shape({}),
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  account: PropTypes.shape(account)
};
